export default __webpack_public_path__ + "static/media/penEdit.8308a7a9.svg";